<template>
    <div class="form">
        <h4 class="step-title">
            How many miles do you drive in a year?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <button-list v-bind:items="annualMileageRanges" v-bind:onclick="complete"/>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "VehicleAnnualMileage",
        components: {
            ButtonList
        },
        data: function() {
            return {
                annualMileageRanges: [
                    { text: "Less than 12,000 miles", value: 12000 },
                    { text: "12,001-15,000 miles", value: 15000 },
                    { text: "15,001-20,000 miles", value: 20000 },
                    { text: "Over 20,000 miles", value: 25000 }
                ]
            }
        },
        props: {
            lead: Object
        },
        computed: {
            vehicle: function() {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            }
        },
        methods: {
            complete: function(vehicleAnnualMileage) {
                this.vehicle.annualMileage = vehicleAnnualMileage;
                this.$emit("complete", this.$options.name, this.vehicle.annualMileage);
            }
        }
    }
</script>
